import React from 'react';
import { SingleSidebar } from '@esg/ui';
import { dashboardSidebarConstants } from '../../Constants';

const dashboardSidebar = dashboardSidebarConstants[0];

export const DashboardSidebar: React.FC = () => {
    return (
        <SingleSidebar
            label={dashboardSidebar.label || ''}
            PreIcon={dashboardSidebar.Icon}
            value={dashboardSidebar.path}
            border
        />
    );
};
